<template lang="pug">
	div.hero
		span.hero-scrollto(@click="scrollTo2nd()")
		.hero-logo
			<Logo class="icon" v-if="content.logo === 'true'" />
		.hero-wrapper
			.hero-video-width
				.hero-video-aspect
					.hero-video-height
						iframe(v-bind:src="'https://player.vimeo.com/video/'+content.video_id+'/?title=0&byline=0&background=1&portrait=1&autoplay=1&loop=1'" width="1600" height="900" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen )
</template>

<script>
import Logo from './logo.svg';

export default {
	name: 'Hero',
	props: ['content'],
	components: {
		Logo
	},
	methods: {
		changeVideoOnScroll() {
			let dom = this.$el.querySelector('.hero-wrapper'),
					scrollActive = false,
					winPos, winH;

			window.addEventListener('scroll', () => {
				winPos = window.scrollY || window.pageYOffset;
				winH = window.innerHeight;
				if(winPos > winH && !scrollActive) {
					scrollActive = true;
					dom.style.visibility = 'hidden';
				} else if(winPos < winH && scrollActive) {
					scrollActive = false;
					dom.style.visibility = '';
				}
			});
		},
		videoPropFullsize() {
			var timeoutId,
					$videoBgAspect = document.querySelector(".hero-video-aspect"),
					$videoBgWidth = document.querySelector(".hero-video-width"),
					videoAspect = $videoBgAspect.offsetHeight / $videoBgAspect.offsetWidth;

			let videoEnlarge = () => {
			  let windowAspect = (window.innerHeight / window.innerWidth);
			  if (windowAspect > videoAspect) {
			    $videoBgWidth.style.width = (windowAspect / videoAspect) * 100 + '%';
			  } else {
			    $videoBgWidth.style.width = 100 + "%";
			  }
			}

			window.addEventListener('resize', () => {
				clearTimeout(timeoutId);
			  timeoutId = setTimeout(videoEnlarge, 80);
			});
			videoEnlarge();
		},
		scrollTo2nd() {
			this.$parent.$parent.winScrollTo(this.$parent.$el.children[1])
		}
	},
	mounted() {
		this.changeVideoOnScroll();
		this.videoPropFullsize();
	}
}
</script>



// WEBPACK FOOTER //
// src/components/features/Hero/index.vue